<template>
    <div>
        <vForm :label-width="120" ref="form" class="margin-15 clearfix">
            <div class="clearfix">
                <vCol span="24" style="border-bottom: 1px dashed #d1d1d1;margin-bottom:15px;">
                    <vCol span="8">
                        <vFormItem :label="$t('', { defaultValue: 'SKU' })" :rules="required" prop="sku">
                            <vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleModal"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('', { defaultValue: '认领数量' })" :rules="required" prop="qty">
                            <vInputNumber v-model="formData.qty" :min="1" math="floor"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="8">
                        <vFormItem :label="$t('', { defaultValue: '建议处理方式' })" :rules="required" prop="goodsReturnType">
                            <vSelect v-model="formData.goodsReturnType">
                                <vOption value=2 label="销毁"></vOption>
                                <vOption value=3 label="上架（良品）"></vOption>
                                <vOption value=0 label="卖家自提"></vOption>
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="16">
                        <vFormItem :label="$t('', { defaultValue: '备注' })">
                            <vInput v-model="formData.remark"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vButton theme="primary" @click="addOne" class="margin-bottom-10" style="margin-left:40px">{{$t('global.common.add', { defaultValue: "添加" })}}</vButton>
                    </vCol>
                </vCol>
            </div>
            <vCol span="24">
                <vButton class="margin-left-10" @click="remove">删除</vButton>
                <vButton class="margin-left-10" theme="primary" @click="clear">清空</vButton>
                <vTable class="margin-top-15" :data="claimPlanOrderItemParamList" border stripe :columns="columnsList"></vTable>
            </vCol>
        </vForm>
        <div class="text-right">
                <vButton class="margin-right-10" theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
        <!-- 公共弹框 -->
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
    </div>
</template>

<script>
import { HttpClaimProduct } from '@/service/salesreturns';
import { mapGetters } from "vuex";
import compErpsku from './erpsku'
import mixin from "../mixin";

export default {
	mixins: [mixin],
    props: ["props"],
    components:{
		compModal: () => import("@components/templates/modal"),
        compErpsku
    },
    data(){
        return {
            claimId: this.props.headId,
            organizationId: this.props.organizationId,
            formData:{
            },
            modalProps: {
				show: false,
			},
            claimPlanOrderItemParamList:[],
            required: [{
                required: true,
                message: this.$t('global.common.fill_requiredd',{defaultValue:'该信息不能为空,请填写'}),
            }],
        }
    },
    computed:{
        ...mapGetters('common', ['getCurrencyList']),
        columnsList(){
            return [
                {
                    type: 'selection',
                    formName: 'id',
                    width: 60,
                },
                {
                    title: 'No.',
                    type:"index",
                },
                {
                    title: this.$t('', { defaultValue: 'SKU' }),
                    key: "sku",
                },
                {
                    title: this.$t('', { defaultValue: '认领数量' }),
                    key: "qty",
                },
                {
                    title: this.$t('', { defaultValue: '建议处理方式' }),
                    key: "goodsReturnType",
                    render: (h, { row }) => {
                        return this.findRenderLabel(this.getHandleType, row.goodsReturnType)
                    }
                },
                {
                    title: this.$t('', { defaultValue: '备注' }),
                    key:"remark",
                }]
        },
    },
    methods:{
        // 查找sku
		handleModal() {
			this.modalProps = {
				show: true,
				width: 1000,
				title: "查找SKU",
				component: "compErpsku",
				showFooter: false,
				props: {
					startUp: true,
				},
				on: {
					"on-data": (row) => {
                        const sku = row.sku
                        const productId = row.id
						this.formData = {
							...this.formData,sku,productId
						};
						this.modalProps = {};
					}
				}
			}
		},
        addOne(){
            let flag = true;
                this.$refs.form.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            let datajson = {
                sku:this.formData.sku,
                productId:this.formData.productId,
                qty:this.formData.qty,
                goodsReturnType:this.formData.goodsReturnType,
                remark:this.formData.remark
            }
            this.claimPlanOrderItemParamList.push(datajson);
            this.formData={}
        },
        remove(index){
            this.claimPlanOrderItemParamList.splice(index,1)
        },
        clear(){
            this.claimPlanOrderItemParamList=[]
        },
        async submit(){
            if( this.claimPlanOrderItemParamList.length === 0 ){
                this.$VMessage.error('请添加SKU');
                return
            }
            this.loading = true;
            this.modalProps = {
				show: true,
				title: "认领",
                desc: "确定全部认领并提交?",
				alert: "error",
				showDesc: true,
                ajaxRequest: async () => {
                    HttpClaimProduct({id: this.claimId, organizationId: this.organizationId, claimPlanOrderItemParamList: this.claimPlanOrderItemParamList }).then( res =>{
                        this.loading = false;
                        this.$VMessage.success('提交成功,请上传相关产品标文件!')
                        this.$emit('on-success')
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    });
                },
			}
            // HttpClaimProduct({id: this.claimId, organizationId: this.organizationId, claimPlanOrderItemParamList: this.claimPlanOrderItemParamList }).then( res =>{
            //     this.loading = false;
            //     this.$emit('on-success')
            // }).catch(err => {
            //     this.$VMessage.error(err.message);
            // });
        },
		cancel() {
            this.$emit('on-success')
		}
    }
}
</script>
